import { render, staticRenderFns } from "./ApprovalLevelsDocument.vue?vue&type=template&id=47199ec7&scoped=true"
import script from "./ApprovalLevelsDocument.vue?vue&type=script&lang=js"
export * from "./ApprovalLevelsDocument.vue?vue&type=script&lang=js"
import style0 from "./ApprovalLevelsDocument.vue?vue&type=style&index=0&id=47199ec7&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "47199ec7",
  null
  
)

export default component.exports